import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import axios from "axios";
import "./registerServiceWorker";

Vue.config.productionTip = false;

const token = localStorage.getItem("bpcbillet.user-token");
if (token) {
  axios.defaults.headers.common["Authorization"] = token;
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
